import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a Date as YYYY-MM-DD using LOCAL date components (NOT UTC).
 *
 * Fixes a timezone bug: `date.toISOString().split('T')[0]` converts to UTC
 * first, so a Date created at local midnight in UTC+1 (e.g. UK BST) becomes
 * the previous day in UTC. That off-by-one breaks date comparisons, booking
 * windows ("tomorrow" sent as "today"), calendars, etc.
 */
export function toLocalDateStr(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Today's date as YYYY-MM-DD in the user's local timezone. */
export function todayLocalStr() {
  return toLocalDateStr(new Date());
}

/** Tomorrow's date as YYYY-MM-DD in the user's local timezone. */
export function tomorrowLocalStr() {
  const t = new Date();
  t.setDate(t.getDate() + 1);
  return toLocalDateStr(t);
}

